import { render } from "./ProjectInformation.vue?vue&type=template&id=4128b20a&ts=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=ts"
export * from "./ProjectInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__